import { getInitials } from '@/utils/formatter';

export interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeMap = {
  sm: '40px',
  md: '48px',
  lg: '64px',
  xl: '96px',
};

const Avatar = ({ name, src, size = 'md', className = '' }: AvatarProps) => {
  const dimension = sizeMap[size];
  const initials = getInitials(name);

  return (
    <div
      className={`nova-avatar ${className}`}
      style={{ width: dimension, height: dimension }}
      aria-label={`Avatar for ${name}`}
      role="img"
    >
      {src ? (
        <img src={src} alt={name} className="nova-avatar-image" />
      ) : (
        <span className="nova-avatar-initials">{initials}</span>
      )}
    </div>
  );
};

export default Avatar;
